import * as React from 'react';
import { isArray } from 'util';
//import { default as Transition } from 'react-transition-group/Transition'; // TODO: when the definition file is fixed
const Transition = require('react-transition-group/Transition').default;

export type Props = {
    visible: boolean;
    height: number | string;
    duration: number | { enter?: number; exit?: number };
    children: any; // tslint:disable-line
    className?: string;
    elementName?: string;
    style?: {};
    unmountOnExit?: boolean;
};

type TransitionState = 'entering' | 'entered' | 'exiting' | 'exited';

const getCollapseStyleByState = (state: TransitionState, height: string): object => ({
    height: state === 'entering' || state === 'entered' ? height : '0',
    opacity: state === 'entering' || state === 'entered' ? 1 : 0,
    overflow: state === 'exited' ? 'hidden' : 'visible',
});


export const FadeCollapse = ({ visible, height, duration, className, children, elementName = 'div', style = {}, unmountOnExit = false }: Props) => {
    const durationIn = typeof duration === 'number' ? duration : duration.enter;
    const durationOut = typeof duration === 'number' ? duration : duration.exit;
    const childrenArray = isArray(children) ? children : [ children ];
    return (
        <Transition in={ visible } timeout={ duration }>
            { (state: TransitionState) =>
                React.createElement(elementName, {
                    className,
                    style: {
                        transition: `all ${state === 'entering' || state === 'entered' ? durationIn : durationOut}ms ease-out`,
                        ...getCollapseStyleByState(state, typeof height === 'number' ? `${height}px` : height),
                        ...style,
                    },
                }, ...((state !== 'exited' || !unmountOnExit) ? childrenArray : []))
            }
        </Transition>
    );
};



// WEBPACK FOOTER //
// ./src/ui/transitions/FadeCollapse.tsx